module.exports = __webpack_public_path__ + "static/media/IN.7fdfdb85.svg";